import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";

export function useHvSubstationById(hvSubstationId?: number | string) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["hvSubstationById", hvSubstationId],
    queryFn: async () => {
      if (hvSubstationId) return await apiContext.assetApis.getHVSubstationById(hvSubstationId);
    },
  });
}
